import React, { SyntheticEvent, useContext } from "react";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import { useTranslate, addNewRelicPageAction } from "../../../helpers";
import { CCXPDropdown } from "../../../components";
import { AppContext } from "../../../app/store";
import { SearchFilterKeys } from "./constants";
import { searchResultsFilterAnalytics } from "./helpers";
import { NewRelicPageActionNames } from "../../../@types";
import { AnalyticsActionType } from "../../../app/contexts/Analytics/types";

interface Props {
  value: string;
  onFilterUpdate: (newValue: string) => void;
  basicMode?: boolean;
}

const StarRatingsFilter: React.FunctionComponent<Props> = ({
  value,
  onFilterUpdate,
  basicMode,
}) => {
  const t = useTranslate();
  const starRatingOptions = Object.keys([...new Array(6)]);
  const { dispatch } = useContext(AppContext);

  const updateFilters = (newValue: string): void => {
    addNewRelicPageAction(NewRelicPageActionNames.SEARCH_RESULTS_FILTER, {
      filter: "Star Ratings",
      value: newValue !== "" ? newValue : "Not Selected",
    });
    dispatch({
      type: AnalyticsActionType.SEND_TEALIUM_EVENT,
      settings: {
        event_action: "Find Plans - Available Plans",
        event_label: "Star Rating Pull down",
      },
    });

    const eventText = choices.find(choice => choice.value === newValue)?.label;
    searchResultsFilterAnalytics({
      dispatch,
      text: eventText,
      filterValue: eventText,
      filterType: SearchFilterKeys.starRatingFilter,
    });

    onFilterUpdate(newValue);
  };

  const label = t("plan_terms.star_rating_filter");
  const choices = starRatingOptions.map(option => ({
    label: `${option} ${
      Number(option) === 5
        ? t("plan_terms.stars")
        : t("plan_terms.stars_and_up")
    }`,
    value: option,
  }));

  return basicMode ? (
    <Dropdown
      onChange={({
        currentTarget: { value },
      }: SyntheticEvent<HTMLSelectElement>): void => {
        updateFilters(value);
      }}
      name="star-rating-filter"
      value={value.toString()}
      label={label}
      id="star-rating-filter"
      options={[
        {
          label: t("plan_terms.select_star_rating"),
          value: "",
        },
        ...choices,
      ]}
    />
  ) : (
    <div className="Filter">
      <CCXPDropdown
        name="star-rating-filter"
        label={label}
        keepDefaultLabel
        value={value}
        options={choices}
        onUpdate={updateFilters}
      />
    </div>
  );
};

export default StarRatingsFilter;
